import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: ["DM Sans", "sans-serif"].join(","),
  },
  palette: {
    primary: {
      main: "#1062b9",
      dark: "#254f98",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#1062b9",
      dark: "#254f98",
      contrastText: "#ffffff",
    },
    background: {
      default: "#f7f8fa",
    },
    text: {
      primary: "#46505f",
      secondary: "#727b88",
    },
  },
  components: {
    MuiSelect: {
      styleOverrides: {
        root: {
          "& .MuiInputBase-input": {
            fontSize: 14,
            padding: "10px 16px",
            color: "#46505f",
            fontWeight: 500,
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "8px", // Custom border radius for buttons
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiInputBase-root": {
            color: "#46505f", // Custom text color for input fields
          },
          border: "solid 1px #cbd2d9",
          height: "40px",
          borderRadius: "8px",
          "& .MuiInputBase-input": {
            fontSize: 14,
            padding: "10px 16px",
            color: "#46505f",
            fontWeight: 500,
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
          "& .MuiInputLabel-animated": {
            display: "none",
          },
        },
      },
    },
  },
});

export default theme;
